<template>
  <PointNotificationPanelSmall
    :url="url"
    class="p-the-a01-point-notification-panel-invested"
    :class="`-${currentColor}`"
  >
    <template #icon>
      <component :is="notificationIcon" />
    </template>
    <template #title>付与基準を<br />達成しました！</template>
    <template #detail>
      <div class="p-the-a01-point-notification-panel-invested__detail">
        <p class="p-the-a01-point-notification-panel-invested__detail__text">
          <!-- ポイント数： -->
          <span class="u-text-weight--bold" data-translate-skip
            >{{ addComma(point) }} {{ unit.point }}</span
          >
        </p>
        <p class="p-the-a01-point-notification-panel-invested__detail__text">
          付与基準: <span data-translate-skip>{{ investedReason }}</span> 
        </p>
      </div>
    </template>
  </PointNotificationPanelSmall>
</template>

<script lang="ts">
import { mapState } from "vuex";
import PointNotificationPanelSmall from "@/general/components/molecules/PointNotificationPanelSmall.vue";
import IconNotificationInvestedBlue from "@/common/components/icons/IconNotificationInvestedBlue.vue";
import IconNotificationInvestedGreen from "@/common/components/icons/IconNotificationInvestedGreen.vue";
import IconNotificationInvestedRed from "@/common/components/icons/IconNotificationInvestedRed.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    title: { type: String, required: true },
    investedReason: { type: String, required: true },
    point: { type: Number, required: true },
    url: { type: String, required: true }
  },
  components: {
    PointNotificationPanelSmall,
    IconNotificationInvestedBlue,
    IconNotificationInvestedGreen,
    IconNotificationInvestedRed
  }
})
export default class A01PointNotificationPanelInvested extends Vue {
  title!: string;
  investedReason!: string;
  point!: number;
  url!: string;

  colors = ["blue", "green", "red"];
  currentColor = "blue";
  unit = commons.unit;

  get notificationIcon() {
    return "IconNotificationInvested" + this.toPascalCase(this.currentColor);
  }

  random(array: any) {
    return array[Math.floor(Math.random() * array.length)];
  }
  toPascalCase(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  created() {
    this.currentColor = this.random(this.colors);
  }

  addComma(value: any) {
    const number = Number(value);
    if (Number.isNaN(number)) {
       return value;
    }
    return number.toLocaleString();
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-point-notification-panel-invested {
  &.-blue {
    background-color: #9cd8d5;
  }

  &.-green {
    background-color: #a9ecd0;
  }

  &.-red {
    background-color: #ff9e98;
  }

  &__detail__text {
    @include text__body--xs;
    color: $common-white;
    overflow-wrap: anywhere;
  }
}
</style>
